import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'pcln-design-system'
import IncredibleTileExperiment from '../../../experiments/IncredibleTileExperiment'
import PricebreakersPromo from '../../promos/pricebreakers-promo'
import VIPPromo from '../../promos/express-promo/VIPPromo'
import BlackFridayPromo from '../../promos/express-promo/BlackFridayPromo'
import ConditionalRender, { Experiment, Original } from '../../../experiments/ConditionalRender'

export default function DesktopPromo ({ isSignedIn }) {
  return (
    <Flex my={3} mx='auto' justifyContent='center'>
      <Flex style={{ maxWidth: '1280px', flex: '1 1 100%' }} px='20px'>
        {/* eslint-disable indent, react/jsx-indent */}
        {isSignedIn
        ? <ConditionalRender experimentCode='MKTG_HP_SIGNEDIN_BLACK_FRI' variantValue='BLACK_FRI'>
            <Experiment>
              <BlackFridayPromo />
            </Experiment>
            <Original>
              <VIPPromo />
            </Original>
          </ConditionalRender>
        : <ConditionalRender experimentCode='MKTG_HP_SIGNEDOUT_BLACK_FRI' variantValue='BLACK_FRI'>
            <Experiment>
              <BlackFridayPromo />
            </Experiment>
            <Original>
              <PricebreakersPromo />
            </Original>
          </ConditionalRender>
        }
        {/* eslint-enable indent, react/jsx-indent */}
        <IncredibleTileExperiment />
      </Flex>
    </Flex>
  )
}

DesktopPromo.propTypes = {
  isSignedIn: PropTypes.bool
}
